import React from 'react';
import { DragSource } from 'react-dnd';
import styles from "./BoxMatch.module.css";

export const Box = ({ name, isDropped, isDragging, connectDragSource }) => {
  const opacity = isDragging ? 0.4 : 1
  const backgroundColor = isDropped ? 'transparent':  'white';
  const border = isDropped ? 'none' : '2px solid #C7C9D9';

  const boxTextItemStyle = { opacity, backgroundColor, border };
  const topKeyholeStyle = {
      border,
      borderTop: "none"
  }

  return connectDragSource(
      <div className={styles.draggable_container}>
        <div className={styles.top_keyhole} style={topKeyholeStyle}></div>
        <div className={styles.box_text_item} style={boxTextItemStyle}>{isDropped ? '' : name}</div>
      </div>
  )
}
export default DragSource(
    props => props.type,
    {
      beginDrag: props => ({ name: props.name }),
  },
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  }),
)(Box)